import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';
import App from './routers';
import { ConfigProvider } from 'antd';
import * as serviceWorker from './serviceWorker';
import { AliveScope } from 'react-activation'
import { BrowserRouter } from 'react-router-dom'
import {Provider} from 'react-redux';
// import configureStore from './redux/store/configureStore'
import store from './redux'
import 'moment/locale/zh-cn';
import zhCN from 'antd/lib/locale/zh_CN';
import './mock'

// const store = configureStore();
ReactDOM.render(
  <ConfigProvider locale={zhCN}>
    <Provider store={store}>
      <BrowserRouter forceRefresh={false}>
        <AliveScope>
          <App />
        </AliveScope>
      </BrowserRouter>
    </Provider>
  </ConfigProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
